import { Linear, Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { ICollider } from "../../Physics/ICollider";

export class AnimatedObstacle extends Obstacle {
    protected static readonly ANIM_KEY: string = "AnimKey";

    protected _anim: HLF.AnimatedSprite;

    constructor(pAnim: HLF.SpriteAnimation, pSpeed: number, pCollider?: ICollider) {
        super(pSpeed, pCollider);

        this._anim = new HLF.AnimatedSprite();
        this._anim.anchor.set(0.5);
        this._anim.addAnimation(AnimatedObstacle.ANIM_KEY, pAnim);
        this._anim.play(AnimatedObstacle.ANIM_KEY);
        this.addChild(this._anim);
        this._anim.update(0);
        this._anim.position.x = this._anim.width * this._anim.anchor.x;
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);
        this._anim.update(pDeltaTime);
    }

    public playDeflectAnim(): void {
        this._speed = 0;
        this._anim.holdFrame(AnimatedObstacle.ANIM_KEY);
        HLF.PixiUtils.sendToFront(this);

        this._deflectAnim = new TimelineLite();
        this._deflectAnim.to(this, 1.5, {
            x: this.x + 250,
            ease: Sine.easeOut,
        }, 0);
        this._deflectAnim.to(this, 0.4, {
            y: this.y - 75,
            ease: Sine.easeOut,
        }, 0);
        this._deflectAnim.to(this, 1.1, {
            y: this.y + 800,
            ease: Sine.easeIn,
        }, 0.4);
        this._deflectAnim.to(this._anim!, 2.0, {
            rotation: this.rotation + Math.PI * 4,
            ease: Linear.easeNone,
        }, 0);
        this._deflectAnim.call(() => {
            this._markedForRemoval = true;
        });
    }
}
